export const YUSA_OVERNIGHT_CAMP_GET_OVERVIEW_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_GET_OVERVIEW_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_GET_OVERVIEW_FAILURE =
  'YUSA_OVERNIGHT_CAMP_GET_OVERVIEW_FAILURE';

export const GET_BRACH_YEAR_WISE_REPORT_SUCCESS =
  'GET_BRACH_YEAR_WISE_REPORT_SUCCESS';
export const GET_BRACH_YEAR_WISE_REPORT_FAILURE =
  'GET_BRACH_YEAR_WISE_REPORT_FAILURE';
